import type { CustomerBlockContent } from '@/blocks/domain/types/BlockContent/CustomerBlockContent';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';
import { fieldsToDto, mapFieldsDto } from '@/blocks/application/mappers/blockFieldsMapper';

export function mapCustomerBlockContent(dto: Extract<BlockContentDto, { kind: 'customer_block' }>): CustomerBlockContent {
  const content: CustomerBlockContent = { kind: 'customer_block', fields: mapFieldsDto(dto.fields ?? []) };
  if (dto.columns !== undefined) content.columns = dto.columns;
  if (dto.sections !== undefined) content.sections = dto.sections;
  return content;
}

export function fromCustomerBlockContent(content: CustomerBlockContent): Extract<BlockContentDto, { kind: 'customer_block' }> {
  const dto: Extract<BlockContentDto, { kind: 'customer_block' }> = { kind: 'customer_block', fields: fieldsToDto(content.fields) };
  if (content.columns !== undefined) dto.columns = content.columns;
  if (content.sections !== undefined) dto.sections = content.sections;
  return dto;
}
